export default "__VITE_ASSET__BIkBQtpm__"